// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaQ = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M4 12a8 8 0 1116 0 8 8 0 01-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-5.256 9.988c0-3.052 1.988-5.236 5.026-5.236s5.054 2.17 5.054 5.236c0 1.568-.546 2.884-1.484 3.808l1.344 1.582v.49h-1.708l-.938-1.148c-.658.294-1.4.476-2.254.476-3.08 0-5.04-2.17-5.04-5.208m8.246-.014c0-2.17-1.218-3.724-3.234-3.724-2.002 0-3.206 1.582-3.206 3.71 0 2.142 1.218 3.752 3.22 3.752s3.22-1.526 3.22-3.738"
    />
  );
export default SvgIconAlphaQ;
